import Auth from 'src/services/api/auth/Auth';

const LANDLORD_LOGIN_PATH = '/landlord/login';

/**
 * Handles client-side logout (for landlord views only)
 * - delete any access tokens from local storage
 * - redirect to login page, with appropriate redirect after logging back in
 * @param nextPath - path to redirect to after logging back in
 *                      if not provided, will not redirect after login
 */
export const redirectToLandlordLogin = (nextPath?: string) => {
    Auth.accessToken = undefined;
    if (nextPath) {
        // prevent circular redirects with vite 431 http error
        if (window.location.href.includes('next_path')) {
            return; // already has a next_path, do nothing
        }
        window.location.href = `/landlord/login?next_path=${nextPath}`;
    } else {
        window.location.href = '/landlord/login';
    }
};

/**
 * Version 2 of the redirect to landlord login
 * The updated version adds query parameters as well
 */
export const redirectToLandlordLoginV2 = () => {
    Auth.accessToken = undefined;

    // Already on the login page: navigating again would reload it and could
    // loop, and its own next_path is the one worth keeping.
    if (window.location.pathname === LANDLORD_LOGIN_PATH) {
        return;
    }

    // Drop any next_path already on the current URL before nesting it into the
    // new one — repeated escaping is what used to blow the URL up into a vite
    // 431 error.
    const search = new URLSearchParams(window.location.search);
    search.delete('next_path');
    const query = search.toString();
    const currentPath = encodeURIComponent(window.location.pathname + (query ? `?${query}` : ''));

    window.location.href = `${LANDLORD_LOGIN_PATH}?next_path=${currentPath}`;
};

export const redirectToPreviousPage = () => {
    window.history.back();
};
